import React, { useState, useEffect } from 'react';
import { Card, makeStyles, CardContent, Typography, CardActions, Button } from '@material-ui/core';
import { getSampleForms, deleteLabResultForm, getFile, deleteFile } from 'utils/SampleFormsUtils';
import { getSamplesByID, updateDeliveryLog } from 'utils/SamplesUtil';
import LabResultsGrid from './LabResultsGrid';
import { useAppContext } from 'hooks/useAppContext';
import { useAuthContext } from 'hooks/useAuthContext';
import Message from 'components/Custom/Message';
import ConfirmationDialog from 'components/Custom/ConfirmationDialog';
import { FormProvider } from 'context/FormContext';
import AddTestProcedureDialog from 'components/Samples/SampleDetails/AddTestProcedureDialog';
import CenteredCircularProgress from 'components/Shared/CenteredCircularProgress';
import UploadAttachmentDialog from './UploadAttachmentDialog';
import { SampleForm } from 'classes';
import AuthCheck from 'components/Shared/AuthCheck';


const useStyles = makeStyles((theme) => ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    cardHeader: {
        "background": theme.palette.primary.main,
        "color": theme.palette.primary.contrastText
    }
}));

const initialState = {
    open: false,
    uploadDialog: false,
    passed: true,
    formName: [],
    sampleByCD: {},
    formsList: [],
    confirmation: false,
    uploadedItem: {},
    uploadError: null,
    selectedForm: ''
}

const LabResultsTab = ({ sample, callback }) => {
    const [st, setSt] = useState(initialState);
    const [PassFail, setPassFail] = useState(false);
    const [loading, setLoading] = useState(false);
    const updateState = (updatedValues) => setSt(prevState => { return { ...prevState, ...updatedValues } })
    const { selectedProject } = useAppContext()
    const handleClose = () => {
        populateGrid()
        updateState({ open: false, uploadDialog: false, uploadError: null })
    }
    const FileUploadDialog = (data, b) => {
        console.log(b);
        updateState({ uploadDialog: true, uploadedItem: data });
    }
    
    const { systemUserId } = useAuthContext()
    const setTestProcedures = () => updateState({ open: true }) //setOpen(true)

    const handleComplete = (status) => {
        setLoading(true);
        const updatedData = st.sampleByCD.SampleDeliveryLogs.map(record => {
            record.PassFail = status
            return record
        })
        updateDeliveryLog(updatedData[0]).then(res => {
            setPassFail(res.passFail);
            callback(res.passFail);
            getSamples();
        }).catch(e => {
            alert("something went wrong");
            setLoading(false);
        })
    };

    const getFormPath = () => import('components/Samples/SampleDetails/AddTestForms');

    const populateGrid = React.useCallback(() => {
        st.sampleByCD.LabResults.length > 0 && st.sampleByCD.LabResults.filter(lr => lr.PassFail.Description === 'N/A').length === 0 ? updateState({ passed: false }) : updateState({ passed: true })
        const data = [];
        st.sampleByCD.LabResults.forEach(lr => {
            data.push(new SampleForm({
                formDesc: lr.LabSampleForm.Description,
                FileUploadUid: lr.FileUploadUid === null ? "" : lr.FileUploadUid,
                FileFriendlyName: lr.FileFriendlyName === null ? "" : lr.FileFriendlyName,
                formId: lr.LabSampleFormId,
                passfail: lr.PassFail.Description,
                DateCreated: lr.DateCreated,
                TestedBy: systemUserId,
                jsonSchema: JSON.parse(lr.ParsedForm).jsonSchema,
                jsonValues: JSON.parse(lr.ParsedForm).values,
                BaseSampleId: lr.BaseSampleId,
                LabResultId: lr.LabResultId,
                PassFailId: lr.PassFailId,
            }))
        })
        updateState({ formName: data,/* confirmation: true */})
    }, [st.sampleByCD.LabResults, systemUserId]);

    const getSamples = React.useCallback(() => {
        setLoading(true);
        getSamplesByID(0, 5, undefined, "", { projectID: selectedProject, SAMPLE_CD: sample.SampleCd }).then(r => {
            updateState({ sampleByCD: r.data[0] })
            r.data[0].SampleDeliveryLogs.forEach(r => {
                setPassFail(r.PassFail)
            });
            setLoading(false);
        })
    }, [sample.SampleCd, selectedProject]);

    useEffect(() => {
        getSampleForms(sample.BaseSampleId,selectedProject).then(r => {
            updateState({ formsList: r.data });
        })
        if (st.sampleByCD.LabResults !== undefined) {
            populateGrid();
        }
        else
            getSamples();
    }, [getSamples, populateGrid, sample.BaseSampleId, st.sampleByCD,selectedProject]);


    const handleFile = async (rowData, del = true) => {
        if (del) {
            await deleteFile(rowData.LabResultId, rowData);
            getSamples()
        } else {
            const res = await getFile(rowData.FileUploadUid);
            window.open(res, '');
        }
    }

    const deleteLabResult = (projectId, labform) => {
        setLoading(true);
        deleteLabResultForm(projectId, labform).then(res => {
            getSamples();
        }).catch(e => {
            alert("something went wrong");
            setLoading(false);
        });
    }

    return (
        // TODO: clean up code split the dialog and match the theme
        <div>
            {
            !loading ?
            <>
            <AddTestProcedureDialog
                BaseSampleId={sample.BaseSampleId}
                sampleByCD={st.sampleByCD}
                open={st.open}
                onClose={handleClose}
                onSumbit={() => {
                    getSamples();
                    updateState({ open: false })
                }}
            />
            <UploadAttachmentDialog
                open={st.uploadDialog}
                onClose={handleClose}
                uploadedItem={st.uploadedItem}
                successCallback={() => {
                    updateState({ open: false, uploadDialog: false, uploadError: null })
                    getSamples()
                }}
            />
            <div><Message msg="Samples received successfully" display={st.confirmation} />
                <Card style={{ minHeight: '100px' }}>
                    <CardContent>
                        {st.formName.length > 0 ?
                            <FormProvider>
                                <LabResultsGrid
                                    columns={SampleForm.columns}
                                    title={"Enter Lab Results"}
                                    deleteRecord={deleteLabResult}
                                    selectedProject={selectedProject}
                                    component="Samples"
                                    formPath={getFormPath}
                                    paging={false}
                                    data={st.formName}
                                    dynamicForm={true}
                                    dynamicFormUpdate={getSamples}
                                    FileUploadDialog={FileUploadDialog}
                                    PassFail={PassFail}
                                    handleFile={handleFile}
                                />
                            </FormProvider>
                            :
                            <Typography color="textSecondary" gutterBottom>
                                No Test Procedure added
                    </Typography>
                        }
                    </CardContent>
                    <AuthCheck scope="Samples" action="update">
                        <CardActions style={{ width: "80%" }}>
                            {!PassFail ?
                                <div>
                                    <Button size="small" color="primary" onClick={setTestProcedures}  >Add Test Procedure</Button>
                                    <ConfirmationDialog
                                        isShowing={false}
                                        buttonText={"Mark Complete"}
                                        message={"Are you sure you want to move the sample from active to completed state ?"}
                                        callback={e => handleComplete(true)}
                                        title={"Sample Complete?"}
                                        disabled={st.passed}
                                    />
                                </div>
                                :
                                <div>
                                    <ConfirmationDialog
                                        isShowing={false}
                                        buttonText={"Mark Active"}
                                        message={"Are you sure you want to move the sample from completed to Active state ?"}
                                        callback={e => handleComplete(false)}
                                        title={"Sample Active?"}
                                        disabled={false}
                                    />
                                </div>
                            }
                        </CardActions>
                    </AuthCheck>
                </Card>
            </div>
            </> : <CenteredCircularProgress />
            }
        </div>
    )
}
export default LabResultsTab
export { useStyles };